var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVirtualSecurityGuardBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 6l1.4 4.1 1.1.1L10 2.8l-2.5 7.5 1.1-.2L10 6zM3.5 9.5l1.6-3.6 1.5 4.6c-.1 0-.8.2-1 .3l-.7-2.1-.8 1.8H2.2c-.1-.5 0-1 0-1h1.3zM13.4 10.4l-.9-.2.5 1.6.4-1.4zM7.5 10.3l-.9.2.4 1.2.5-1.4zM17.8 10.5h-1.9l-.8-1.8-.7 2-1-.3L15 5.9l1.5 3.6h1.3s.1.5 0 1z",
    fill: "#1998D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4 10.1c-1.4-.1-2.8 0-2.8 0L7 14.9l-1.4-4.1c-1.9.5-3 1.2-3 1.2.9 3.3 3.9 5.7 7.4 5.7 3.6 0 6.6-2.4 7.4-5.7-1-.6-2-1-3-1.3l-1.5 4.2-1.5-4.8z",
    fill: "#1998D5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10C0 4.5 4.5 0 10 0s10 4.5 10 10-4.5 10-10 10S0 15.5 0 10zm1 0c0 5 4 9 9 9s9-4 9-9-4-9-9-9-9 4-9 9z",
    fill: "#1998D5"
  })));
}
export default SvgVirtualSecurityGuardBlue;